// 休日：平日で、祝日を含めて記載してください。
const holidays = [
  "2025-03-20",
  "2025-04-29",
  "2025-04-30",
  "2025-05-01",
  "2025-05-02",
  "2025-05-03",
  "2025-05-04",
  "2025-05-05",
  "2025-05-06",
  "2025-06-20",
  "2025-07-21",
  "2025-08-11",
  "2025-08-12",
  "2025-08-13",
  "2025-08-14",
  "2025-08-15",
  "2025-08-18",
  "2025-09-15",
  "2025-09-23",
  "2025-10-13",
  "2025-11-03",
  "2025-11-24",
  "2025-12-29",
  "2025-12-30",
  "2025-12-31",
  "2026-01-01",
  "2026-01-02",
  "2026-01-12",
  "2026-02-11",
  "2026-02-23",
  "2026-03-20"
];

const holidays_sap = [
  "2025-04-29",
  "2025-05-03",
  "2025-05-04",
  "2025-05-05",
  "2025-05-06",
  "2025-07-21",
  "2025-08-11",
  "2025-09-15",
  "2025-09-23",
  "2025-10-13",
  "2025-11-03",
  "2025-11-24",
  "2025-12-31",
  "2026-01-01",
  "2026-01-02",
  "2026-01-12",
  "2026-02-11",
  "2026-02-23",
  "2026-03-20"
];